import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appPercentageMask]'
})
export class PercentageMaskDirective {

    constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) { }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        let rawValue = input.value.replace('%', '');

        this.control.control.setValue(rawValue, { emitEvent: false });

        // מוסיפים % רק לתצוגה
        if (rawValue.length > 0) {
            this.renderer.setProperty(input, 'value', rawValue + '%');
        } else {
            this.renderer.setProperty(input, 'value', '');
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const input = event.target as HTMLInputElement;

        if (event.key === 'Backspace') {
            event.preventDefault();

            const newValue = input.value.slice(0, input.value.length - 2);
            this.control.control.setValue(newValue, { emitEvent: false });

            if (newValue.length > 0) {
                this.renderer.setProperty(input, 'value', newValue + '%');
            } else {
                this.renderer.setProperty(input, 'value', '');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/percentageMask.directive.ts